import { Form } from "antd";

import ExportButton from "@/components/Export/ExportButton";

import FilterSelect from "./FilterSelect";
import { useFilters } from "./hooks/useFilters";

const ExportAssetType = () => {
  const [params, setFilters] = useFilters();

  return (
    <Form layout="vertical">
      <FilterSelect
        model="assetTypes"
        onChange={(value) => setFilters("id", value)}
      />

      <ExportButton model="assetTypes" params={params} />
    </Form>
  );
};

export default ExportAssetType;
